import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import BlogDetail from 'components/BlogDetail'
import { StoriesStore } from 'stores/stories'
import { useStoryPageView, useStore } from 'hooks'
import { getStaticWrapper, getStoryKeyValues, isMobile, storyCanonicalRedirect } from 'utils'
import useTeads from 'hooks/teads'

const BlogDetailPage = ({ story }) => {
  useStore(StoriesStore, { current: story })
  useStoryPageView(story)

  const adSettings = {
    slot: 'standard-post',
    revContentSlot: 'Standard-Post',
    keyValues: getStoryKeyValues(story)
  }

  useTeads(process.env.TEADS_PAGE_ID)

  return (
    <SiteLayout adSettings={adSettings}>
      <Head story={story} />
      <BlogDetail adSettings={adSettings} />
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper(async ({ params }) => {
  const { id } = params
  const interstitialInterval = 4
  const story = await StoriesStore().findById(id, { interstitialInterval })
  const redirect = storyCanonicalRedirect(story, 'blog', params)
  if (redirect) {
    return redirect
  }
  return {
    story
  }
})

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export default BlogDetailPage
